<template>
  <div class="container">
    <h4>View not found <a href="/" style="font-size: 1.2rem" class="ml-2">Go home</a> </h4> 
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>